import { createPortal } from 'react-dom';

export const BaseModal = ({ children }) => {
  return createPortal(children, document.body);
};
